import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/liposuction-zayiflama-yontemi-midir-gercekler-ve-yanilgilar/page.tsx");
